import React, { useState } from 'react';

const Step10VoiceMessages = ({ onNext, currentData }) => {
  const [selected, setSelected] = useState(currentData?.extraFields?.voiceMessages || null);

  const handleSelect = (value) => {
    setSelected(value);
    setTimeout(() => {
      onNext({ 
        extraFields: { 
          ...currentData.extraFields, 
          voiceMessages: value 
        } 
      });
    }, 500);
  };

  return (
    <div className="step step-yesno">
      <div className="analyzing-text">Analyzing your desires...</div>
      <div className="yesno-image-container">
        <img 
          src="https://cdn.lovescape.com/cdn/front/images/marketing/10page.webp" 
          alt="Voice Messages" 
          className="yesno-image"
        />
      </div>
      <h2 className="step-title">Would you like to receive voice messages?</h2>
      <div className="yesno-buttons">
        <button 
          className={`yesno-button ${selected === 'yes' ? 'selected' : ''}`}
          onClick={() => handleSelect('yes')}
        >
          Yes
        </button>
        <button 
          className={`yesno-button ${selected === 'no' ? 'selected' : ''}`}
          onClick={() => handleSelect('no')}
        >
          No
        </button>
      </div>
    </div>
  );
};

export default Step10VoiceMessages;